<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="preface">
<h1>Preface</h1>
<p>All these stories have actually happened to me or my coworkers over the past ten years I’ve been grooming. Names have been changed to protect human dignity. Human dignity is much more fragile than a dog’s dignity.</p>
<p>I was inspired to record my stories down by many family members and friends. It all started while working crazy overtime over holidays and the end of the year. I would come home too exhausted to even tell my husband about my day. I decided to write him a note. “Remind me to tell you about Jinx and his mom. Remind me to tell you about impacted anal glands on this poor dog yesterday.” I would come home the next day even more tired. I just decided to write a little synopsis of my day so we would still be communicating. Those notes turned into little stories.</p>
<p>I also had to have the funniest or craziest stories summarized or jotted down in order to entertain a young client of mine. Her dog is my dog’s litter mate (sister). Every two months, I would groom Angelica’s dog, and she would ask me, “Have you groomed any crazy dogs recently? Any funny stories or mad owners?” I would look at my sticky note to remind myself what had happened over the past three months since I’d groomed Lucky.</p>
<p>Angelica can take some credit for giving me the idea to put these all down in a cohesive manner.</p>
<p>These stories are funny because of the crazy, obnoxious, and humorous things that owners and pets have done. I have many request clients that I love dearly, the doggie and their human parents. Many of them are not mentioned in this book, unfortunately. I could not continue to do my job without their support and kindness over the years. They know who they are. My sincere hope is they realize how much I care for them.</p>
<p>Just to reiterate, these events really happened. This is my life as a groomer.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?7883143a